import { dsl } from '@wix/yoshi-serverless/wrap';

export const challenge = dsl({
          functionName: 'challenge',
          fileName: 'api/challenges/challenge.api',
        });